import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { AvatarWebElement } from './AvatarWebElement';
export { AvatarWebElement };

/**
 * Retrieve an instance of [AvatarWebElement](../classes/AvatarWebElement.html).
 * @example
 * ```javascript
 * import { findAvatar } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findAvatar(driver, By.id('my-oj-c-avatar'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findAvatar(driver: DriverLike, by: By): Promise<AvatarWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type AvatarWebElement
  if (!(webEl instanceof AvatarWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'AvatarWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findAvatar(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${AvatarWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-avatar', AvatarWebElement);
